// import CourseReviewCard from "./components/CourseReviewCard";
import { useEffect, useState } from "react";
import Data from "../../data/career_services1.json";
import CareerServicesRequirementCard from "./components/CareerServicesRequirementCard";
import CareerServicesCurriculumLeftCard from "./components/CareerServicesCurriculumLeftCard";
import CareerServicesCurriculumRightCardNew from "./components/CareerServicesCurriculumRightCardNew";
import CareerServicesCurriculumLeftCardNew from "./components/CareerServicesCurriculumLeftCardNew";

function CareerServicesAI() {
  const [width, setWidth] = useState(window.innerWidth);
  const [activeCurriculum, setActiveCurriculum] = useState(Data?.curriculum[0]);

  const handleClick = item => {
    console.log('onClick', item, activeCurriculum);
    
    if (width < 768 && item.id === activeCurriculum.id) {
      setActiveCurriculum({})
    } else {
      setActiveCurriculum(item)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);

      if (window.innerWidth > 768) {
        setActiveCurriculum(Data?.curriculum[0])
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container">
      <div className="row text-center mx-auto col-12">
      <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Full Stack Developer</b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}> Syllabus</b></h2><br/>
        <div className="w-100 mt-md-2 mb-5 sub-title">
        Logicmojo provides Live, Interactive Online Sessions guided by Professionals working in top MNCs. 
        All sessions are covered practically with real-time industrial projects and case studies
        </div>
        <div className="row curriculum">      
        <div className="col-11 right">
              <div className="meta-section d-flex flex-column align-items-center">
                    <a target="_default" href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view">Course Brochure</a>
                  </div>
          </div>
          </div>
        {/* requirement */}
        
        {/* -/- requirement */}
        {/* Curriculum */}
        <div className="row curriculum">
          <div className="col-1 left d-flex flex-column align-items-center">
            <div className="circle-wrapper d-flex justify-content-center align-items-center">
              <span>1</span>
            </div>
            <div className="line-gradient"></div>
          </div>
          <div className="col-11 right">
            <div className="position-relative heading">
              <p style={{ fontSize: 24 }} className="text-left">Logicmojo Curriculum</p>
              <img
                className="position-absolute"
                src="assets/images/sketch_line_heading.svg"
                alt=""
              />
            </div>
            <div className="row">
              <div className="col-md-6 inner-left">
                {Data?.curriculum.map((item) => (
                  <CareerServicesCurriculumLeftCardNew handleClick={handleClick} {...item} width={width} activeCurriculum={activeCurriculum} />
                ))}
              </div>
              <div className={`col-md-6 inner-right ${width < 768 ? 'd-none' : ''}`}>
                <CareerServicesCurriculumRightCardNew {...activeCurriculum?.topices} />
              </div>
            </div>
            <div className="meta-section d-flex flex-column align-items-center">
              <a target="_blank" href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-09">Explore Program</a>
            </div>
          </div>
        </div>
        {/* -/- Curriculum */}
        {/* services */}
        
        {/* -/- services */}
        {/* requirement */}
        
        {/* -/- requirement */}
      </div>
    </div>
  );
}
export default CareerServicesAI;
